import tinycolor from 'tinycolor2';

import { isDefined, randomColor } from '@hsp/utilities';

import { IClient } from 'types/api/client';
import { s } from 'utilities/strings';

export const useExternalClients = (clients: IClient[], useExternal: boolean) => {
  if (!useExternal) {
    return clients;
  }

  const data = [...clients] as IClient[];
  const hasExternal = isDefined(data.find(({ id }) => id === '-1'));

  const backgroundColor = tinycolor(randomColor({ addHash: true }) as string)
    .lighten(10)
    .setAlpha(0.5);
  const color = backgroundColor.isDark() ? backgroundColor.clone().lighten(80) : backgroundColor.clone().darken(80);

  const external: IClient = {
    backgroundColor: backgroundColor.toHslString(),
    color: color.toHslString(),
    id: '-1',
    name: s(['Site.External', 'Site.Client']),
  };

  return hasExternal ? data : [external, ...data];
};
